module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TFv4Sy/image/front.jpg?1726850954205",
      "alt": "This image is the cover for the book Barafa the Snow Leopard"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Barafa the Snow Leopard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("These stories have been written to introduce young readers to the natural world and the wonderful and rare creatures that live in it. The stories in the book provide factual detail and extrapolations on the lives of the animals, as told by the animals themselves, and invites the young ready into a special world that is rarely seen or heard from. The animal characters are larger than life and engaging. The stories carry messages about kindness and friendship and the need to preserve the natural world for future generations of both animals and humans.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Paul Jordan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Paul was born in Canberra in 1983, and following high school, enrolled at the Australian National University from which he graduated with a Bachelor of Arts, Graduate Diploma in Arts, Master of Translation. In 2009, Paul was diagnosed with Asperger’s Syndrome (Autism) on the high end of the spectrum and learned Acceptance and Commitment Therapy from an octogenarian former psychology professor. He devotes his time to assisting young people on the spectrum by writing on the subject and coaching on an individual basis. He also works in his mother’s legal practice where he is responsible for updating, reviewing, and maintaining the legal precedents library.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0